import React, { useRef, useState } from "react";
import EExchangeVoucherForm from "./EEV-form";
import {
  Avatar,
  Chip,
  colors,
  Container,
  Divider,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from "@material-ui/core";
import { uri } from "../../../../../help/Api";
import TotalCard from "../../../../../components/TotalCard";
import ExternalFormSub from "../components/External-form-sub";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";
import { useStylesHed } from "../../../../../St/comps/UseStyle";
import toast from "react-hot-toast";
import useFormDataCRUD from "../../../../../components/Hooks/useEDSCURD";
import EExchangeAPI from "../../../../../api/EExchange";
import {
  ERVdefaultValues,
  getEndDept,
} from "../../../../../services/EReceiptVoucher-service";
import axios from "axios";
import { sto } from "../../../../../Context/InshData";
import EExchangeVoucherAppBar from "./EExchangeVoucher-AppBar";
import { IRReFormatingData } from "../../../../../services/IReceipt-service";
import { useTranslation } from "react-i18next";
import { addArchaiveFile, addMultiArchaiveFile, handleDownloadFiles, handleInputSearchCustomers, handleMultiDownloadFiles, viewHandleCustomers } from "../../../../Invs/BackEnd/components/SearchItemsFunction";
 export const useStylesSand = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  root2: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(3),
  },
  rootMu: {
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingRight: theme.spacing(1),
    paddingBottom: theme.spacing(10),
  },
  itemW: {
    width: "90%",
  },

  allWidth: {
    minWidth: 650,
  },
  checStyl: {
    marginTop: "17px",
    fontSize: "16px",
    padding: "-1px",
  },
  avatar: {
    backgroundColor: colors.grey[600],
    color: "#fff",
    height: 46,
    width: 46,
    marginTop: -5,
  },
  icon: {
    height: 32,
    width: 32,
  },
  card: {
    backgroundColor: colors.grey[100],
    height: "100px",
    color: colors.grey[900],
    borderWidth: "0px",
    borderStyle: "solid",
    fontSize: "26px",
  },
}));
 export const isMobileDevice = () => {
  return /Mobi|Android|iPhone|iPad/i.test(navigator.userAgent);
};
export function GetIndexFromIdOptions(id, options) {
  const index = options.findIndex((op) => op.id == id);
  return options[index];
}
export function GetEmpFromOptions(id, options) {
  const index = options?.findIndex((op) => op.emp == id);
  return options[index];
};


export default function EExchangeVoucher(props) {
  const { AutoOptions, fetchURL, prmis, isDialog, item, onClose,
    AutoOptionsB,
    branch,
    setBranch,db_name
   } = props;
   const [branchT, setBranchT] = useState(sto.branchi);
   const [optionsStocks, setOptionsStocks] = useState(AutoOptions?.Stocks);

  const defaultV = isDialog
    ? IRReFormatingData({ ...item }, AutoOptions)
    : {
        ...ERVdefaultValues,
        id: AutoOptions.other.lastid,
        user:GetIndexFromIdOptions(sto.idi,AutoOptions.Users),
        stock: AutoOptions.Stocks[0],
        bank: AutoOptions.Banks[0],
        emp:GetIndexFromIdOptions(sto.idi,AutoOptions.Users),
      };
  const {
    onChange,
    submit,
    update,
    remove,
    submitting,
    errorMessage,
    onShow,
    onEnd,
    object,
    formType,
    getRow
  } = useFormDataCRUD(
    EExchangeAPI.create,
    EExchangeAPI.update,
    EExchangeAPI.remove,
    undefined,
    defaultV,
    null,
    () => {
      // if (isDialog) onClose(true);
      // else fetchURL();
    },
    isDialog ? "edit" : "new",
    EExchangeAPI.GetRow
  );

  const { t } = useTranslation(["translation", "forms"]);
  const changAutoCustomers = async (newValue) => {
    let end_dept1 = "0.0";
    let Urls = null;
    if (sto.db_name === "" || sto.db_name === null) {
      Urls = `AccountReports/rptABalanceSum?branch=${-1}&&costCenter=${-1}&&acc_code=${newValue.acc_no.toString()}`
    } else {
      Urls = `AccountReports/rptABalanceSum?branch=${-1}&&costCenter=${-1}&&acc_code=${newValue.acc_no.toString()}
      &&db_name=${db_name}`
    }
    await axios
      .get(
        uri +Urls
      )
      .then((res) => {
        end_dept1 = res.data.end_Dept - res.data.end_Credit;
      })
      .catch((res) => {
        toast.error("لم يتم جلب مديونية العميل");
        console.log("erro", res.error);
      });

    let nObject = {
      ...object,
      customer: newValue,
      end_Dept: end_dept1,
      notes: "دفعة لحساب " + newValue.name,
    };

    onShow(nObject, formType);
  };
  const [optionsCustomers, setOptionsCustomers] = useState(AutoOptions.Customers);
  const [listSelectApi, setListSelectApi] = useState([]);
  const countCustomers=AutoOptions.Customers.length==300?true:false;
  const [searchCustText, setSearchCustText] = useState("");

  const searchTimeout=useRef(null);
  const handleInputSearchCust = (event, newValue, reason) => {
    const optionsAll=[...listSelectApi,... AutoOptions.Customers]
    handleInputSearchCustomers(newValue, optionsAll, searchTimeout, setOptionsCustomers, 
        countCustomers,2,true,setSearchCustText, reason)
};
const handleIconSearchCust = () => {
  if (countCustomers && searchCustText) {
    const optionsAll=[...listSelectApi,... AutoOptions.Customers]
    viewHandleCustomers(searchCustText,setOptionsCustomers,true,2,-1,optionsAll); 
  }
};
  const classes = useStylesSand();
  const clashd = useStylesHed();
  const [file, setFile] = useState(null);
  const [files, setFiles] = useState([]);
  const addArchaive = async (data) => {
    let nameFile="ExchangeSand"+data.id+data.branch;
    // addArchaiveFile(file,nameFile);
    addMultiArchaiveFile(files, nameFile);
};
  const handleDownload = async () => {
    try {
      let nameFile="ExchangeSand"+object.id+branch.id;
      //  await handleDownloadFiles(nameFile) ; 
       await handleMultiDownloadFiles(nameFile);
    } catch (error) {
    }
};
  return (
    <>
      <div className={ isMobileDevice?classes.root2:classes.root} style={{ direction: "rtl" }}>
        <Grid item container className={clashd.rootHd}>
          <Grid item xs={12}>
            <Chip
              size="medium"
              className={clashd.ChipHdAccount}
              style={{ fontSize: "16px" }}
              label={t("translation:ext-exchange")}
              color="primary"
            />
          </Grid>
        </Grid>
        <Typography
          component="div"
          style={{ direction: "rtl", marginTop: "20px" }}
        >
          <Grid container justifyContent="center" spacing={3}>
            <Grid item lg={9} md={8} sm={12}>
              <Container
                component={Paper}
                maxWidth={false}
                style={{
                  padding:isMobileDevice? "12px": "35px",
                  borderTopColor: colors.grey[500],
                  borderTopWidth: "2px",
                  borderTopStyle: "solid",
                }}
              >
                <EExchangeVoucherForm
                  {...{
                    ...props,
                    object,
                    formType,
                    changAutoCustomers,
                    onChange,
                    AutoOptionsB,
                    branch,
                    setBranch,
                    branchT,
                    optionsStocks,
                    handleInputSearchCust,
                    optionsCustomers,
                    handleIconSearchCust,
                    isMobileDevice,
                    prmis,
                    setFile,
                    handleDownload,
                    setFiles,
                    files,
                    db_name
                  }}
                />
                {/* <CurrencySalesProfitForm {...{AutoOptions, rptParams, onChangeData, onChangeAutoData}} /> */}
              </Container>
            </Grid>
            <Grid item lg={3} md={4} sm={12}>
              <TotalCard
                {...{
                  className: classes.card,
                  title: t("forms:account-balance-to-date"),
                  value: getEndDept(object.end_Dept),
                }}
              />
              <br />
              <Container
                component={Paper}
                maxWidth={true}
                style={{
                  padding: "20px",
                  borderBottomWidth: "0px",
                }}
              >
                <Grid container justify="space-between">
                  <Grid item>
                    <Typography
                      style={{ paddingTop: "8px" }}
                      variant="h4"
                      component="h4"
                    >
                      {t("forms:check-data")}
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Avatar className={classes.avatar}>
                      <AttachMoneyIcon className={classes.icon} />
                    </Avatar>
                  </Grid>
                </Grid>
                <Divider />
                <br />

                <ExternalFormSub
                  {...{
                    ...props,
                    object,
                    changAutoCustomers,
                    onChange,
                  }}
                />

                <br />
              </Container>
            </Grid>
          </Grid>
        </Typography>
      </div>
      <EExchangeVoucherAppBar
        {...{
          URL: EExchangeAPI.URL,
          prmis,
          ...props,
          onChange,
          submit,
          update,
          defaultV,
          remove,
          submitting,
          errorMessage,
          onShow,
          onEnd,
          object,
          formType,
          getRow,
          AutoOptions,
          branch,
          branchT,
          setBranchT,
          AutoOptionsB,
          setOptionsStocks,
          setOptionsCustomers,
          setListSelectApi,
          file,
          addArchaive,
          setFiles,
          files,
          db_name
        }}
      />
    </>
  );
}
